import { number, object } from "superstruct";

export const RewardsB2bCompanyPointBalanceSchema = object({
    pointBalance: number(),
});
